import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { TerminologyEntity } from '@app/domain/terminology/model/terminology-entity.enum';
import { GoalsMessages } from '@app/goals/goals.messages';
import { GoalsAPIService } from '@app/shared/api/goals.api.service';
import { Globals } from '@app/shared/globals/globals';

@Component({
  selector: 'app-goal-create-part-weighting',
  templateUrl: './goal-create-part-weighting.component.html',
  styleUrls: ['./goal-create-part-weighting.component.scss']
})
export class GoalCreatePartWeightingComponent {

  public readonly eTerminologyEntity = TerminologyEntity;
  public readonly eGoalsMessages = GoalsMessages;

  @Input() controlWeightings: UntypedFormControl;
  @Input() controlWeight: UntypedFormControl;
  @Input() submitted: boolean;
  @Input() submittedDraft: boolean;
  @Input() parentDropdownOpen: boolean;

  @Output() onSetParentDropdown: EventEmitter<boolean>;

  constructor(
    private goalsAPIService: GoalsAPIService,
    public globals: Globals
  ) {
    this.controlWeightings = new UntypedFormControl(null, []);
    this.controlWeight = new UntypedFormControl(null, []);
    this.submitted = false;
    this.submittedDraft = false;
    this.parentDropdownOpen = true;
    this.onSetParentDropdown = new EventEmitter<boolean>();
  }

  setParentDropdown(expanded: boolean): void {
    this.onSetParentDropdown.emit(expanded);
  }


}
